import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { addToPartnerCart } from '../pages/reducer/slices/partnerCartSlice';
import { makeAuthenticatedPATCHRequest } from '../pages/services/serverHelper';
import { partnerPoints } from '../pages/services/apis';
import { toast } from 'react-toastify';
import { FaShoppingCart } from "react-icons/fa";

const PLACEHOLDER_IMAGE = "https://via.placeholder.com/400x300.png?text=No+Image";

const PartnerOfferingCard = ({ product }) => {
  const dispatch = useDispatch();
  const partnerCartItems = useSelector((state) => state.partnerCart?.cartItems || []);
  const [isDisabled, setIsDisabled] = useState(false);
  const { accessToken } = useSelector(state => state.auth);

  const handleAddToCart = async (e) => {
    e.preventDefault();

    if (!accessToken) {
      toast.error("Please log in to add items to cart.");
      return;
    }

    try {
      const response = await makeAuthenticatedPATCHRequest(
        `${partnerPoints.PUSH_PARTNER_CART_ITEM}`,
        { productId: product._id, userId: localStorage.getItem('artId') },
        accessToken
      );

      if (response.statusCode === 200) {
        dispatch(addToPartnerCart(product));
        setIsDisabled(true);
        toast.success(`${product.offeringKind || 'Item'} added to cart.`);
      } else {
        toast.error(response?.message || `${product.offeringKind || 'Item'} not added to cart.`);
      }
    } catch (error) {
      console.error('Error adding partner item to cart:', error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    if (partnerCartItems.some(item => item._id === product._id)) {
      setIsDisabled(true);
    }
  }, [partnerCartItems, product._id]);

  const displayPrice = product?.discountPrice > 0 && product?.discountPrice < product?.price
    ? product.discountPrice
    : product?.price;

  return (
    <div className="product-card">
      <div className="product-card-img-top">
        <img
          src={product?.mainImage || PLACEHOLDER_IMAGE}
          alt={product?.name}
          className="product-card-img-top"
          style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          onError={(e) => { e.target.onerror = null; e.target.src = PLACEHOLDER_IMAGE; }}
        />
      </div>
      <div className="product-card-body">
        <div>
          <div className='product-card-body-details'>
            <div>
              <h5 className="product-card-text-title">{product?.name}</h5>
              <p className="product-card-text-tag">
                {product?.category}{product?.artSector ? ` · ${product.artSector}` : ''}
              </p>
            </div>
            <p className="product-cardproduct-price">
              ₹ {Number(displayPrice || 0).toFixed(2)}
              {product?.discountPrice > 0 && product?.discountPrice < product?.price && (
                <span style={{ textDecoration: 'line-through', color: '#999', fontSize: '0.8em', marginLeft: '6px' }}>
                  ₹ {Number(product.price).toFixed(2)}
                </span>
              )}
            </p>
          </div>
          <div className="product-card-detail">
            <Link to={`/partner-offering/${product._id}`} className="link-btn">
              View Description
            </Link>
          </div>
        </div>
        <button
          className="cart-btn"
          onClick={handleAddToCart}
          style={{ alignContent: 'flex-end', gap: "10px", backgroundColor: isDisabled ? '#7c7474' : '#ad2020' }}
          disabled={isDisabled}
        >
          <FaShoppingCart />
          {isDisabled ? 'Added To Cart' : 'Add to Cart'}
        </button>
      </div>
    </div>
  );
};

export default PartnerOfferingCard;
